<template lang="pug">
	div
		div.card
			div.card-header.bg-info.text-white
				span.fa.fa-search.mr-2
				| Filtrar los datos
			.card-body
				.row
					.col-sm-12.col-md-12.col-lg-4.col-xl-4
						div(v-if="permisos.producciones_verEstadisticasTodos")
							.form-group(v-if="!filtro.ID_agente")
								label Agente
								input-query(input-class="form-control", placeholder="Busca un anunciante", :realtime="true", url="produccion/php/api/buscaAgente.php", @selected="seleccionaAgente($event)")
							.form-group(v-else)
								label Agente
								.input-group
									input.form-control(:value="agente.UsuarioNombre", disabled)
									.input-group-append
										button.btn.btn-danger(@click="filtro.ID_agente = null")
											span.fa.fa-trash
						.form-group(v-if="!filtro.ID_anunciante")
							label Anunciante
							input-query(input-class="form-control", placeholder="Busca un anunciante", :realtime="true", :url="'produccion/php/api/buscaAnunciante.php?ID_agente=' + filtro.ID_agente", @selected="seleccionaAnunciante($event)")
						.form-group(v-else)
							label Anunciante
							.input-group
								input.form-control(disabled, :value="anunciante.nombre")
								.input-group-append
									button.btn.btn-danger(@click="filtro.ID_anunciante = null")
										span.fa.fa-trash
					.col-sm-12.col-md-12.col-lg-4.col-xl-4
						.form-group
							label Desde
							datepicker(
								:bootstrap-styling="true"
								v-model="filtro.fechaInicio"
								:language="$dateLang"
								:monday-first="true"
							)
						.form-group
							label Hasta
							datepicker(
								:bootstrap-styling="true"
								v-model="filtro.fechaFin"
								:language="$dateLang"
								:monday-first="true"
							)
					.col-sm-12.col-md-12.col-lg-4.col-xl-4
						| Personalización
						p.mt-2
							label(style="cursor: pointer;")
								input.mr-3(type="checkbox", name="producidas", v-model="filtro.excluirNoProducidas")
								| Excluír campañas sin producción
						p.mt-2
							label(style="cursor: pointer;")
								input.mr-3(type="checkbox", name="canceladas", v-model="filtro.omitirCanceladas")
								| Omitir producciones canceladas
						p.mt-2
							label(style="cursor: pointer;")
								input.mr-3(type="checkbox", name="externas", v-model="filtro.omitirExternas")
								| Omitir producciones externas

			.card-footer
				button.btn.btn-primary(@click="consultar") Consultar
		div.card.mt-4(style="display:none;")
			.card-header Ideas
			.card-body
				ul
					li [OK] 10 locutores más populares
					li [OK] Voces externas vs voces internas
					li [OK] Nº versiones por tarea
					li [OK] Ranking de agentes
					li [OK] Agentes que más rechazan
					li [OK] Fases en las que más rechazos hay
					li [OK] Tiempo medio en cada fase
					li [OK] Producciones externas vs producciones internas
					li [OK] % de producciones express
					li Días de la semana vs creacion de tareas
					li Días de la semana vs tareas finalizadas
					li [OK] Tareas totales + Versiones
					li Tareas por meses
		.row
			.col-xs-12.col-sm-12.col-md-6.col-lg-8.col-xl-8
				// Gráficos de barras
				div.card.mt-4(v-if="resultados.tareasPorMeses")
					.card-header Tareas por meses
					.card-body
						chartjs-line(
							:beginatzero="true"
							:title="{display: true, text: 'Locutores Populares'}"
							label="Locutores populares"
							:legend="{display: false}"
							:height="200"
							:labels="resultados.tareasPorMeses.labels"
							:datasets="resultados.tareasPorMeses.datasets"
						)


				div.card.mt-4(v-if="resultados.locutoresPopulares")
					.card-header Locutores más utilizados
					.card-body
						chartjs-bar(
							:beginatzero="true"
							:title="{display: true, text: 'Locutores Populares'}"
							label="Locutores populares"
							:legend="{display: false}"
							:height="200"
							:labels="resultados.locutoresPopulares.labels"
							:datasets="resultados.locutoresPopulares.datasets"
						)

				div.card.mt-4(v-if="resultados.versionesTareas")
					.card-header Versiones por tarea
					.card-body
						chartjs-bar(
							:beginatzero="true"
							label="Versiones tareas"
							:height="200"
							:labels="resultados.versionesTareas.labels"
							:datasets="resultados.versionesTareas.datasets"
						)

				div.card.mt-4(v-if="resultados.rankingAgentes")
					.card-header Producciones por agente
					.card-body
						chartjs-bar(
							:beginatzero="true"
							label="Versiones tareas"
							:height="200"
							:labels="resultados.rankingAgentes.labels"
							:datasets="resultados.rankingAgentes.datasets"
						)

				div.card.mt-4(v-if="resultados.rankingRechazan")
					.card-header Rechazos por agente
					.card-body
						chartjs-bar(
							:beginatzero="true"
							label="Versiones tareas"
							:height="200"
							:labels="resultados.rankingRechazan.labels"
							:datasets="resultados.rankingRechazan.datasets"
						)

				div.card.mt-4(v-if="resultados.tiempoMedio")
					.card-header Tiempo medio por fase
					.card-body
						chartjs-bar(
							:beginatzero="true"
							label="Versiones tareas"
							:height="200"
							:labels="resultados.tiempoMedio.labels"
							:datasets="resultados.tiempoMedio.datasets"
							:option="resultados.tiempoMedio.options"
						)

				div.card.mt-4(v-if="resultados.tareasMasVersiones")
					.card-header
						| Sobrecargo en producción
						.badge.badge-warning.ml-2(style="font-size:1.3em;") {{(resultados.tareasMasVersiones.datasets[0].data[1] * 100 / resultados.tareasMasVersiones.datasets[0].data[0]).toFixed(2)}} %
					.card-body
						chartjs-bar(
							:beginatzero="true"
							label="Sobrecargo producción"
							:height="200"
							:labels="resultados.tareasMasVersiones.labels"
							:datasets="resultados.tareasMasVersiones.datasets"
							:option="resultados.tareasMasVersiones.options"
						)

			.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-4
				// Resúmen totales
				.card.mt-4(v-if="resultados.tareasTotales")
					.card-header.bg-warning Totales
					.card-body
						p
							b Total tareas:
							|  {{resultados.tareasTotales.tareas | currency('', 0)}}
						p
							b Total textos:
							|  {{resultados.tareasTotales.textos | currency('', 0)}}
							span.badge.bg-danger.text-white.ml-2(style="font-size:1.1em;") {{Math.round(resultados.tareasTotales.textos * 100 / resultados.tareasTotales.tareas)}} %
						p
							b Total producciones:
							|  {{resultados.tareasTotales.producciones | currency('', 0)}}
							span.badge.bg-danger.text-white.ml-2(style="font-size:1.1em;") {{Math.round(resultados.tareasTotales.producciones * 100 / resultados.tareasTotales.tareas)}} %
				// Gráficos de quesos
				div.card.mt-4(v-if="resultados.vocesExternas")
					.card-header Procedencia del locutor/a
					.card-body
						chartjs-pie(
							v-bind:option="{}"
							label="Voces externas"
							datalabel="VocesExternas"
							:height="200"
							:labels="resultados.vocesExternas.labels"
							:data="resultados.vocesExternas.datasets[0].data"
						)

				div.card.mt-4(v-if="resultados.locutoresGenero")
					.card-header Locutores por género
					.card-body
						chartjs-pie(
							v-bind:option="{}"
							label="Voces externas"
							datalabel="locutoresGenero"
							:height="200"
							:labels="resultados.locutoresGenero.labels"
							:data="resultados.locutoresGenero.datasets[0].data"
						)

				div.card.mt-4(v-if="resultados.rankingFases")
					.card-header
						| Rechazos por fase
					.card-body
						chartjs-pie(
							v-bind:option="{}"
							label="Fases de rechazo"
							datalabel="rankingFases"
							:height="200"
							:labels="resultados.rankingFases.labels"
							:data="resultados.rankingFases.datasets[0].data"
						)

				div.card.mt-4(v-if="resultados.externasInternas")
					.card-header
						| Producciones externas vs internas
						.badge.badge-warning.ml-2(style="font-size:1.3em;") {{(resultados.externasInternas.datasets[0].data[0] * 100 / (resultados.externasInternas.datasets[0].data[1] + resultados.externasInternas.datasets[0].data[1])).toFixed(2)}} %
					.card-body
						chartjs-pie(
							v-bind:option="{}"
							label="Voces externas"
							datalabel="externasInternas"
							:height="200"
							:labels="resultados.externasInternas.labels"
							:data="resultados.externasInternas.datasets[0].data"
						)

				div.card.mt-4(v-if="resultados.produccionesExpress")
					.card-header
						| Producciones express
						.badge.badge-warning.ml-2(style="font-size:1.3em;") {{(resultados.produccionesExpress.datasets[0].data[0] * 100 / (resultados.produccionesExpress.datasets[0].data[0] + resultados.produccionesExpress.datasets[0].data[1])).toFixed(2)}} %
					.card-body
						chartjs-pie(
							v-bind:option="{}"
							label="Voces externas"
							datalabel="produccionesExpress"
							:height="200"
							:labels="resultados.produccionesExpress.labels"
							:data="resultados.produccionesExpress.datasets[0].data"
						)

</template>

<script>
import { mapGetters } from 'vuex'
export default {
	data () {
		return {
			filtro: {
				ID_agente: null,
				ID_anunciante: null,
				fechaInicio: null,
				fechaFin: null,
				excluirNoProducidas: true,
				omitirCanceladas: true,
				omitirExternas: false
			},
			anunciante: null,
			agente: null,
			resultados: {}
		}
	},
	computed: {
		...mapGetters({
			permisos: 'permisos/permisos',
			usuario: 'session/usuario'
		})
	},
	methods: {
		seleccionaAgente (info) {
			this.agente = info.datos
			this.filtro.ID_agente = info.datos.ID
		},
		seleccionaAnunciante (info) {
			this.anunciante = info.datos
			this.filtro.ID_anunciante = info.datos.ID_anunciante
		},
		consultar () {
			const form = JSON.parse(JSON.stringify(this.filtro))
			form.fechaInicioUnix = (this.filtro.fechaInicio) ? Math.floor(this.filtro.fechaInicio.getTime() / 1000) : null
			form.fechaFinUnix = (this.filtro.fechaFin) ? Math.floor(this.filtro.fechaFin.getTime() / 1000) : null
			this.resultados = {}
			this.$http.post('produccion/php/api/estadisticas/calcular.php', form)
				.then(res => {
					this.resultados = res.data
				})
				.catch(e => {
					console.error(e)
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/estadisticas/estadisticas.vue